import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ListadaAgrupada, ConfigService } from '../../../infrastructure/services/config.service';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs/Observable';

@Component({
    templateUrl: './configurar.output.component.html',
})
export class ConfigurarOutputComponent implements OnInit, OnDestroy {
    readonly level = "Output";

    systemCode: string;
    outputCode: string;

    grupos: Observable<ListadaAgrupada[]>;
    cargando: Boolean = true;
    subsGetConfiguracion: Subscription;
    organizationCode: string;

    constructor(private aRoute: ActivatedRoute, private configService: ConfigService) { }

    ngOnInit() {

        this.aRoute.params.subscribe((params: Params) => {
            // Parametros URL
            this.organizationCode = params['codorganizacion'];
            this.systemCode = params['codsistema'];
            this.outputCode = params['codoutput'];
            this.grupos = this.configService.getConfiguracion(this.organizationCode,
                this.systemCode, 
                null, 
                null, 
                this.level, 
                this.outputCode);
        });
    }

    ngOnDestroy() {
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/output/configurar.output.component.ts